export default __webpack_public_path__ + "static/media/Certificate-Default.05917301.svg";